export class VarianceWorklistSearchRequest{
    center:string;
    searchCriteria:string;

    constructor(center:string,searchCriteria:string){
        this.center = center;
        this.searchCriteria = searchCriteria;
    }
}